import { create } from "zustand";
import { Screen, DetailsStep } from "@/types/Navigation";
import {
  scrollToTop,
  enableBeforeUnload,
  disableBeforeUnload,
} from "@/utils/dom";
import { dispatchEvent } from "@/utils/event-dispacher";
import { EventName } from "@/types/Events";

export type NavigationState = {
  screen: Screen;
  visibleDetailsSteps: DetailsStep[];
  currentDetailsStep: DetailsStep | null;
  setScreen: (screen: Screen) => void;
  setCurrentDetailsStep: (step: DetailsStep | null) => void;
  removeVisibleDetailsSteps: (steps: DetailsStep[]) => void;
};

export const useNavigationStore = create<NavigationState>((set, get) => ({
  screen: Screen.Amount,
  visibleDetailsSteps: [],
  currentDetailsStep: null,
  setScreen: (screen) => {
    scrollToTop();

    if (screen === Screen.Details) {
      enableBeforeUnload();
    }

    if (screen === Screen.Success) {
      disableBeforeUnload();
    }

    set({ screen });
  },
  setCurrentDetailsStep: (step) => {
    if (step === null) {
      set({ currentDetailsStep: null });
      return;
    }

    dispatchEvent(EventName.STEP_CHANGE, {
      step_name: step,
    });

    const { visibleDetailsSteps } = get();
    if (!visibleDetailsSteps.includes(step)) {
      set((state) => ({
        visibleDetailsSteps: [...state.visibleDetailsSteps, step],
      }));
    }
    set({ currentDetailsStep: step });
  },
  removeVisibleDetailsSteps: (steps) =>
    set((state) => ({
      visibleDetailsSteps: state.visibleDetailsSteps.filter(
        (step) => !steps.includes(step),
      ),
    })),
}));
